import { render, staticRenderFns } from "./DesignFormTempletList.vue?vue&type=template&id=1db2958b&scoped=true&"
import script from "./DesignFormTempletList.vue?vue&type=script&lang=js&"
export * from "./DesignFormTempletList.vue?vue&type=script&lang=js&"
import style0 from "./DesignFormTempletList.vue?vue&type=style&index=0&id=1db2958b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db2958b",
  null
  
)

export default component.exports